import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledDrawer = styled.div<{
  $visible: boolean;
  $bgVariant?: 'primary' | 'secondary';
  $alwaysShowOnDesktop?: boolean;
}>`
  padding: ${tvar('space.x3')} ${tvar('space.x2')};
  background: ${({ theme, $bgVariant }) =>
    $bgVariant === 'primary'
      ? theme.colors.fill.primary
      : theme.colors.neutrals.grey2};
  margin-right: ${tvar('space.double')};
  max-width: min(40rem, 90vw);
  transition: transform 0.2s ease-in-out;
  transform: ${({ $visible }) =>
    $visible ? 'translateX(0)' : 'translateX(-100%)'};
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  z-index: 5;
  overflow-x: hidden;
  overflow-y: auto;

  @media (min-width: ${tvar('measures.breakpoints.tabletLg')}) {
    ${({ $alwaysShowOnDesktop }) =>
      $alwaysShowOnDesktop
        ? `
        height: auto;
        position: static;
        transform: translateX(0);
      `
        : ''}
  }
`;
